import * as React from 'react';

import AxaLogo from 'assets/InsuresV2/axa.png';
import BolivarLogo from 'assets/InsuresV2/bolivar.png';
import EquidadLogo from 'assets/InsuresV2/equidad.png';
import EstadoLogo from 'assets/InsuresV2/estado.png';
import HdiLogo from 'assets/InsuresV2/hdi.png';
import SbsLogo from 'assets/InsuresV2/sbs.png';
import SuraLogo from 'assets/InsuresV2/sura.png';
import LibertyLogo from 'assets/InsuresV2/liberty.png';
import ZurichLogo from 'assets/InsuresV2/zurich.png';
import MapfreLogo from 'assets/InsuresV2/mapfre.png';
import PrevisoraLogo from 'assets/InsuresV2/previsora.png';
import SolidariaLogo from 'assets/InsuresV2/solidaria.png';
import QualitasLogo from 'assets/InsuresV2/qualitas.png';

enum Insurances {
  AXA = 'AXA',
  BOLIVAR = 'BOLIVAR',
  EQUIDAD = 'EQUIDAD',
  ESTADO = 'ESTADO',
  HDI = 'HDI',
  MAPFRE = 'MAPFRE',
  SBS = 'SBS',
  SURA = 'SURA',
  LIBERTY = 'LIBERTY',
  ZURICH = 'ZURICH',
  HDI_B = 'HDI_B',
  PREVISORA = 'PREVISORA',
  SOLIDARIA = 'SOLIDARIA',
  QUALITAS = 'QUALITAS',
}
const InsuranceLogoV2: React.FC<IInsuranceLogoPropsReSize> = ({ insurance }) => {
  let logoSrc;
  let widthIn;
  let heigthIn;

  switch (insurance) {
    case Insurances.AXA:
      logoSrc = AxaLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.BOLIVAR:
      logoSrc = BolivarLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.EQUIDAD:
      logoSrc = EquidadLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.ZURICH:
      logoSrc = ZurichLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.ESTADO:
      logoSrc = EstadoLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.HDI:
      logoSrc = HdiLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.MAPFRE:
      logoSrc = MapfreLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.SBS:
      logoSrc = SbsLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.SURA:
      logoSrc = SuraLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.LIBERTY:
      logoSrc = LibertyLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.HDI_B:
      logoSrc = HdiLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.PREVISORA:
      logoSrc = PrevisoraLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.SOLIDARIA:
      logoSrc = SolidariaLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    case Insurances.QUALITAS:
      logoSrc = QualitasLogo;
      widthIn = '105';
      heigthIn = '105';
      break;
    default:
      return null;
  }

  return (
    <div style={{ width: `${widthIn}px`, height: `${heigthIn}px`, overflow: 'hidden' }}>
      <img
        src={logoSrc}
        alt={`${insurance} logo`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default InsuranceLogoV2;
